module.exports = __webpack_public_path__ + "src/assets/models/molar/spoon_0_1_w_salt.fbx";